import React, { lazy } from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const items = [{
    label: 'Produit Principal',
    text: 'Pilates Prêt — La Méthode Complète'
  }, {
    label: 'Bonus 1',
    text: 'Le Carnet des Transitions Fluides'
  }, {
    label: 'Bonus 2',
    text: 'L\'Aide-Mémoire "Props & Accessoires"'
  }, {
    label: 'Bonus 3',
    text: 'Le Guide Marketing pour Studios FR'
  }, {
    label: 'Bonus 4',
    text: "Checklist de l'Instructeur d'Élite"
  }, {
    label: 'Bonus 5',
    text: 'Le Lexique Français-Anglais du Pilates'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-192">
      <div className="max-w-5xl mx-auto" data-id="element-193">
        <div className="text-center mb-12" data-id="element-194">
          <div className="bg-pilates-lavender/25 text-pilates-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-195">
            La solution que vous attendiez — Un système 6 en 1
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-196">
            6 livres en 1, conçus spécifiquement pour les{' '}
            <span className="italic text-pilates-sage-dark" data-id="element-197">
              professionnels
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-198">
          <div data-id="element-199">
            <img src="https://cdn.magicpatterns.com/uploads/988bYnGKoQkwizPHuxZ3Jx/heylloyd-image-1779985889202.webp" alt="Coffret Pilates Prêt" className="w-full rounded-2xl shadow-xl" loading="lazy" decoding="async" width="800" height="800" data-id="element-200" />
          </div>

          <div data-id="element-201">
            <p className="text-pilates-slate text-base leading-relaxed mb-6" data-id="element-202">
              <span className="font-bold text-pilates-dark" data-id="element-203">PILATES PRÊT</span>{' '}
              est bien plus qu'un simple livre d'exercices. C'est un système
              opérationnel complet qui vous livre 60 séances de 55 minutes,
              structurées pédagogiquement pour garantir fluidité et confiance en
              studio.
            </p>
          </div>
        </div>
      </div>
    </section>;
}